import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@src/components/ui/button/button';
import { useFormContext } from 'react-hook-form';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Drawer } from '@mui/material';
import { AutoCompleteInput } from '@src/components/ui/react-hook-form/autocomplete-input/autocomplete-input';
import { CheckOptionInput } from '@src/components/ui/react-hook-form/check-option-input/check-option-input';

export const OrderFilter = props => {
    const { isSidebarOpen, onToggleSidebar } = props;
    const { handleSubmit, setValue, formState } = useFormContext();
    const isLoading = formState.isSubmitting;

    const handleReset = () => {
        setValue('timestamp', '');
        setValue('statuses', []);
    };

    const handleFilterClick = async () => {
        setValue('keyword', '');
        setValue('page', 1);
        await handleSubmit();
        onToggleSidebar();
    };

    return (
        <Drawer
            open={isSidebarOpen}
            onClose={onToggleSidebar}
            PaperProps={{
                className:
                    'tw-w-[350px] tw-max-w-[calc(100vw-70px)] tw-overflow-visible tw-shadow-none tw-pt-[70px] tw-bg-transparent'
            }}
            ModalProps={{
                BackdropProps: {
                    style: { backgroundColor: 'transparent' }
                }
            }}
        >
            <div className='tw-relative tw-flex tw-flex-col tw-border tw-border-black/12 tw-grow tw-bg-white'>
                <div className='tw-grow tw-overflow-auto tw-overflow-x-d-none tw-h-1'>
                    <div className='tw-font-medium tw-p-[16px]'>Filter Purchase Order History</div>
                    <div className='tw-space-y-[14px] tw-border-b tw-border-black/12 tw-p-[16px]'>
                        <div className='tw-font-medium'>TIMESTAMP</div>
                        <AutoCompleteInput
                            name='timestamp'
                            options={[
                                { label: 'Newest to Oldest - Order Issue Date', value: '-datetimecreated' },
                                { label: 'Oldest to Newest - Order Issue Date', value: 'datetimecreated' }
                                // { label: 'Newest to Oldest - Task Date', value: '-datetimecreated' },
                                // { label: 'Oldest to Newest - Task Date', value: 'datetimecreated' }
                            ]}
                            className='tw-w-full'
                            InputProps={{
                                placeholder: 'Select Timestamp'
                            }}
                        />
                    </div>
                    <div className='tw-space-y-[14px] tw-p-[16px]'>
                        <div className='tw-font-medium'>TASK STATUS</div>
                        <CheckOptionInput
                            name='statuses'
                            options={[
                                {
                                    label: 'Upcoming',
                                    value: 'Created,Collected,Acknowledged,Preparing,Shipped,Ready for Pick-up'
                                },
                                { label: 'Completed', value: 'Completed' },
                                { label: 'Cancelled', value: 'Cancelled,Rejected' }
                            ]}
                        />
                    </div>
                </div>

                <div className='tw-flex tw-gap-[8px] tw-border-t tw-border-black/12 tw-p-[16px]'>
                    <Button variant='outlined' className='tw-grow' onClick={handleReset}>
                        RESET
                    </Button>
                    <Button onClick={handleFilterClick} variant='contained' className='tw-grow' loading={isLoading}>
                        APPLY
                    </Button>
                </div>

                <Button
                    variant='contained'
                    className='tw-absolute tw-right-0 tw-rotate-[270deg] tw-origin-top-right lg:tw-d-none'
                    endIcon={
                        <KeyboardArrowDown
                            className={`tw-transition-transform ${isSidebarOpen ? 'tw-rotate-180' : ''}`}
                        />
                    }
                    onClick={onToggleSidebar}
                >
                    <span className='tw-flex-grow'>FILTERS</span>
                </Button>
            </div>
        </Drawer>
    );
};

OrderFilter.propTypes = {
    isSidebarOpen: PropTypes.bool,
    onToggleSidebar: PropTypes.func.isRequired
};
